// Must be first — captures beforeinstallprompt before React mounts.
import "./pwaInstallCapture";
import React from "react";
import ReactDOM from "react-dom/client";
import { applyThemeMode, getInitialThemeMode } from "./utils/themeMode";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { registerRootServiceWorker } from "./services/serviceWorkerRegistration";

/* ✅ THIS LINE IS REQUIRED */
import "./i18n";

applyThemeMode(getInitialThemeMode());

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    void registerRootServiceWorker();
  });
}
